'use client'
import { useTranslations } from 'next-intl'
import type { JSX } from 'react'

import OutlineButton from '@/components/Button/OutlineButton'
import ErrorScreen, { type ErrorScreenProps } from '@/components/ErrorScreen'
import RefreshButton from '@/components/ErrorScreen/RefreshButton'
import { type ErrorType } from '@/lib/errors'

interface ErrorProps extends ErrorScreenProps {
  type?: ErrorType
}

const Error = ({ title, message, type }: ErrorProps): JSX.Element => {
  const t = useTranslations('error')

  const buttons = (
    <>
      <RefreshButton />

      {type === 'api' && (
        <OutlineButton asChild>
          <a href={t('buttons.checkApiStatus.url')} target="_blank">
            {t('buttons.checkApiStatus.label')}
          </a>
        </OutlineButton>
      )}
    </>
  )

  return <ErrorScreen buttons={buttons} message={message ?? t('defaultMessage')} title={title ?? t('defaultTitle')} />
}

export default Error
